const applications = Object.freeze({
  Provider: '153125d6-dec8-420f-9b14-2238fcb4b1bc',
});

export default applications;
